/* eslint-disable */
import React, { Component } from 'react';
import HTMLText from './HTMLText'

class RadioButton extends Component {

	constructor(props) {
		super(props);
		
		this.state = {	
			name : this.props.name,		
			className : this.props.className,
			dataField : this.props.dataField,
			value : this.props.value,
			text : this.props.text,
			curValue:this.props.curValue
		};
		this.onChange = this.onChange.bind(this);
	
	}
	
	componentDidMount() {		
	}
	
	componentWillUnmount() {
	}

	componentWillReceiveProps(nextProps) {
		this.setState({className:nextProps.className, value:nextProps.value,text : nextProps.text,curValue : nextProps.curValue});
	} 
	
	

	onChange(e){
		var stringValue = e.target.value;
		this.props.parent.setState({[this.props.dataField]:stringValue});
	}


	render() {
		return (
			<React.Fragment>		
				<input type="radio" className={this.props.className} name={this.props.name} value={this.state.value} 
					checked={this.state.value === this.state.curValue} onChange={this.onChange} id={this.props.name + this.props.value}/>
				<label htmlFor={this.props.name + this.props.value}>
					<HTMLText text={this.state.text}/>
				</label>
					
			</React.Fragment>			
		);
	}
}


export default RadioButton;